var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: "Sopimuskumppanin tiedot",
        "header-text-variant": _vm.headerTextVariant,
        "body-text-variant": _vm.bodyTextVariant,
        "header-bg-variant": _vm.headerBgVariant,
        "no-close-on-backdrop": "",
        "hide-backdrop": "",
        "content-class": "shadow"
      },
      on: { hide: _vm.hide },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "primary" },
                  on: {
                    click: function($event) {
                      return cancel()
                    }
                  }
                },
                [_vm._v("\n          " + _vm._s(_vm.$t("Poista")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "primary" },
                  on: {
                    click: function($event) {
                      return ok()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("Hyväksy")) + "\n      "
                  )
                ]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _vm.contactPerson
        ? [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "form-group col-md-6" }, [
                _c("label", { attrs: { for: "contactPerson_firstName" } }, [
                  _vm._v(_vm._s(_vm.$t("Etunimi")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contactPerson.FirstName,
                      expression: "contactPerson.FirstName"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "contactPerson_firstName" },
                  domProps: { value: _vm.contactPerson.FirstName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.contactPerson,
                        "FirstName",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-6" }, [
                _c("label", { attrs: { for: "contactPerson_lastName" } }, [
                  _vm._v(_vm._s(_vm.$t("Sukunimi")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contactPerson.LastName,
                      expression: "contactPerson.LastName"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "contactPerson_lastName" },
                  domProps: { value: _vm.contactPerson.LastName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.contactPerson,
                        "LastName",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-6" }, [
                _c("label", { attrs: { for: "contactPerson_pin" } }, [
                  _vm._v(_vm._s(_vm.$t("Henkilötunnus")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contactPerson.Pin,
                      expression: "contactPerson.Pin"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "contactPerson_pin" },
                  domProps: { value: _vm.contactPerson.Pin },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.contactPerson, "Pin", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-6" }, [
                _c("label", { attrs: { for: "contactPerson_phone" } }, [
                  _vm._v(_vm._s(_vm.$t("Puhelinnumero")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contactPerson.Phone,
                      expression: "contactPerson.Phone"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "contactPerson_phone" },
                  domProps: { value: _vm.contactPerson.Phone },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.contactPerson, "Phone", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group col-md-12" }, [
                _c("label", { attrs: { for: "contactPerson_email" } }, [
                  _vm._v(_vm._s(_vm.$t("Sähköpostiosoite")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contactPerson.Email,
                      expression: "contactPerson.Email"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "contactPerson_email" },
                  domProps: { value: _vm.contactPerson.Email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.contactPerson, "Email", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group col-md-5" },
                [
                  _c("label", { attrs: { for: "contactPerson_pastalcode" } }, [
                    _vm._v(_vm._s(_vm.$t("Postinumero")))
                  ]),
                  _vm._v(" "),
                  _c("postal-autocomplete", {
                    attrs: {
                      id: "contactPerson_pastalcode",
                      place: _vm.contactPerson.Address.Place,
                      "street-locale": _vm.locale
                    },
                    on: {
                      "postal-code-selected": _vm.postalSelected,
                      "post-office-selected": _vm.postOfficeSelected
                    },
                    model: {
                      value: _vm.contactPerson.Address.Zip,
                      callback: function($$v) {
                        _vm.$set(_vm.contactPerson.Address, "Zip", $$v)
                      },
                      expression: "contactPerson.Address.Zip"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      textContent: _vm._s(_vm.contactPerson.Address.Place)
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group col-md-7" },
                [
                  _c("label", { attrs: { for: "contactPerson_street" } }, [
                    _vm._v(_vm._s(_vm.$t("Katuosoite")))
                  ]),
                  _vm._v(" "),
                  _c("street-autocomplete", {
                    attrs: {
                      id: "contactPerson_street",
                      "postal-filter": _vm.contactPerson.Address.Zip,
                      locale: _vm.locale,
                      "show-full-address": true
                    },
                    on: {
                      "street-selected": _vm.streetSelected,
                      "street-address-selected": _vm.addressSelected
                    },
                    model: {
                      value: _vm.street,
                      callback: function($$v) {
                        _vm.street = $$v
                      },
                      expression: "street"
                    }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }